import type { FriendimizerUser as FriendimizerUserType } from '@sweetistics/contracts';
import { FriendimizerStatsSchema, FriendimizerUserSchema } from '@sweetistics/contracts';
import { z } from 'zod';
import type {
  ArenaCacheDetailResponse as ArenaCacheDetailResponseType,
  ArenaCacheListItem as ArenaCacheListItemType,
  ArenaCacheListResponse as ArenaCacheListResponseType,
  ArenaCacheParticipant as ArenaCacheParticipantType,
} from './arena/index';

export {
  FriendimizerDataResponseSchema,
  FriendimizerFiltersSchema,
  FriendimizerImpactPaginationSchema,
  FriendimizerImpactResponseSchema,
  FriendimizerStatsResponseSchema,
  FriendimizerStatsSchema,
  FriendimizerUserSchema,
} from '@sweetistics/contracts';

export function validateFriendimizerData(data: unknown): z.infer<typeof FriendimizerUserSchema>[] {
  const result = z.array(FriendimizerUserSchema).safeParse(data);
  return result.success ? result.data : [];
}

export function validateFriendimizerStats(data: unknown): z.infer<typeof FriendimizerStatsSchema> | null {
  const result = FriendimizerStatsSchema.safeParse(data);
  return result.success ? result.data : null;
}

export type FriendimizerUser = FriendimizerUserType;

export type ArenaCacheDetailResponse = ArenaCacheDetailResponseType;
export type ArenaCacheListItem = ArenaCacheListItemType;
export type ArenaCacheListResponse = ArenaCacheListResponseType;
export type ArenaCacheParticipant = ArenaCacheParticipantType;

export {
  ArenaCacheDetailResponseSchema,
  ArenaCacheListItemSchema,
  ArenaCacheListResponseSchema,
  ArenaCacheParticipantSchema,
  serializeArenaCacheDetailResponse,
  serializeArenaCacheListResponse,
  serializeArenaRealtimeTokenResponse,
} from './arena/index';
